import { useReducer, useRef } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { MapContext, MapReducer } from "../mapbox/context";
import { MapContextDataset } from "../mapbox/context/types";
import { DEFAULT_VIEWPORT } from "../mapbox/utils/map-utils";
import { FunctionType } from "../utils/type";

import MapContextWrapper from "./MapContextWrapper";

export enum MapTabs {
    map = "map",
    configuration = "configuration",
    savedViews = "savedViews",
}

export enum MapTableTabs {
    map = "map",
    table = "table",
    split = "split",
}

export type MapTableTabsType = {
    readonly tab: MapTableTabs;
    readonly setTab: (t: MapTableTabs) => void;
    readonly openSaveViewPopper: boolean;
    readonly setOpenSaveViewPopper: React.Dispatch<
        React.SetStateAction<boolean>
    >;
};

export interface IMapViewWrapper {
    readonly savedViewId?: string;
    readonly currentTab?: MapTabs;
    readonly mapTemplateId?: string;
    readonly isSavedAreaForm?: boolean;
    readonly isGlobalTemplate?: boolean;
    readonly datasets: MapContextDataset[];
    readonly isFromDataSamples?: boolean;
}

const MapViewWrapper = ({
    savedViewId,
    currentTab,
    mapTemplateId,
    datasets,
    isFromDataSamples,
    ...props
}: IMapViewWrapper) => {
    const map = useRef<mapboxgl.Map | null>(null);
    const draw = useRef<MapboxDraw | null>(null);

    const [state, dispatch] = useReducer(MapReducer, {
        map,
        draw,
        isMapLoaded: false,
        isLoading: { data: false, boundaries: false },
        mapStyle: undefined,
        datasets,
        polygons: [],
        viewport: DEFAULT_VIEWPORT,
        functionType: FunctionType.viewport,
        socketResponses: {
            responses: {},
        },
    });

    return (
        <DndProvider backend={HTML5Backend}>
            <MapContext.Provider value={{ ...state, dispatch }}>
                <MapContextWrapper
                    {...props}
                    datasets={datasets}
                    savedViewId={savedViewId}
                    currentTab={currentTab}
                    mapTemplateId={mapTemplateId}
                    isFromDataSamples={isFromDataSamples}
                />
            </MapContext.Provider>
        </DndProvider>
    );
};

export default MapViewWrapper;
